@if (form) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12 gap-2" novalidate>
    <app-form-text-input [form]="form" [twoColumns]="true" id="code" label="CHOP.CODE"></app-form-text-input>
    <app-form-number-input
      [form]="form"
      [min]="0"
      [twoColumns]="true"
      id="punkteVon"
      label="CHOP.PUNKTE_VON"></app-form-number-input>
    <app-form-number-input
      [form]="form"
      [min]="0"
      [twoColumns]="true"
      id="punkteBis"
      label="CHOP.PUNKTE_BIS"></app-form-number-input>
    <app-form-number-input
      [form]="form"
      [maxFractionDigits]="2"
      [min]="0"
      [minFractionDigits]="2"
      [twoColumns]="true"
      id="betrag"
      label="CHOP.BETRAG"
      suffix=" CHF"></app-form-number-input>
    <app-form-text-input [form]="form" id="bezeichnung.De" label="GLOBAL.NAME_De"></app-form-text-input>
    <app-form-text-input [form]="form" id="bezeichnung.Fr" label="GLOBAL.NAME_Fr"></app-form-text-input>
    <app-form-text-input [form]="form" id="bezeichnung.It" label="GLOBAL.NAME_It"></app-form-text-input>
    <app-form-button-bar (onCancel)="cancel()" [form]="form" [saveDisabled]="submitting"></app-form-button-bar>
  </form>
}
